import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-phone-missed",
  templateUrl: "./med-icon-phone-missed.component.html",
})
export class MedIconPhoneMissedComponent extends SvgMixinComponent {}
